import React, { useState, useEffect } from "react";
import { makeStyles } from "@mui/styles";
import styles from "../../styles/headerStyle.js";
import { useTranslation } from "react-i18next";
import logo from "../../assets/img/haraka-logo.png";
import menu from "../../assets/img/menu.svg";
import langicon from "../../assets/img/system-uicons_translate.svg";
import { useSelector } from "react-redux";
import { Close, ExpandLess, ExpandMore } from "@mui/icons-material";
import { Link, useLocation, useNavigate } from "react-router-dom";
import moment from "moment";
import appstore from "../../assets/img/Button.svg";
import playstore from "../../assets/img/Button (1).svg";
import { handleAppStoreClick } from "../../common/appStoreUtils";
const useStyles = makeStyles(styles);

export default function Header(props) {
  const { i18n, t } = useTranslation();
  const location = useLocation();
  const navigate = useNavigate();
  const classes = useStyles();
  const languagedata = useSelector((state) => state.languagedata);
  const settings = useSelector((state) => state.settingsdata.settings);
  const { profile } = useSelector((state) => state.auth);
  const [langSelection, setLangSelection] = useState();
  const [multiLanguage, setMultiLanguage] = useState();
  const [hoveredTitle, setHoveredTitle] = useState("");
  const [toggleMenu, setToggleMenu] = useState(false);

  const links = [
    {
      link: "/",
      title: "headerHome",
    },
    {
      link: "/contact-us",
      title: "contactus",
    },
  ];

  const accountLinks = [
    {
      link: "/login",
      title: "login",
    },
    {
      link: "/login?signup=true",
      title: "login_signup",
    },
  ];

  const [toggleLang, setToggleLang] = useState(false);

  const handleLanguageSelect = (event) => {
    i18n.addResourceBundle(
      multiLanguage[event].langLocale,
      "translations",
      multiLanguage[event].keyValuePairs
    );
    i18n.changeLanguage(multiLanguage[event].langLocale);
    setLangSelection(event);
    moment.locale(multiLanguage[event].dateLocale);
    setToggleLang(false);
  };

  const [scrolling, setScrolling] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 100) {
        setScrolling(true);
      } else {
        setScrolling(false);
      }
    };

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  useEffect(() => {
    if (languagedata.langlist) {
      for (const key of Object.keys(languagedata.langlist)) {
        if (languagedata.langlist[key].langLocale === i18n.language) {
          setLangSelection(key);
        }
      }
      setMultiLanguage(languagedata.langlist);
    }
  }, [languagedata.langlist, i18n.language]);

  return (
    <div>
      <div className={classes.spacings}>
        <div
          className={
            scrolling
              ? classes.outterScrollingContainer
              : classes.outterContainer
          }
        >
          <div className={classes.headerDiv}>
            <div className={classes.navContainer}>
              <div className={classes.navLinkContainerOne}>
                <img
                  onClick={() => navigate("/")}
                  src={logo}
                  alt="logo"
                  className={classes.headerLogo}
                />
                <div className={classes.navLinkContainer}>
                  {links?.map((link, index) => {
                    return (
                      <div key={index}>
                        <Link
                          style={{ textDecoration: "none", color: "inherit" }}
                          to={link.link}
                        >
                          <p
                            onMouseEnter={() => setHoveredTitle(link?.link)}
                            onMouseLeave={() => setHoveredTitle("")}
                            // onClick={() => navigate(link.link)}
                            style={
                              hoveredTitle === link.link ||
                              location.pathname === link.link
                                ? {
                                    textDecoration: "3px solid underline",
                                    textUnderlineOffset: "10px",
                                  }
                                : {}
                            }
                            className={classes.headerLink}
                          >
                            {t(link?.title)}
                          </p>
                        </Link>
                      </div>
                    );
                  })}
                </div>
              </div>

              {/* MOBILE */}
              <div className={classes.mobileNavLangContainer}>
                <div
                  onClick={() => setToggleLang(!toggleLang)}
                  className={classes.headerLangDivSection}
                >
                  <div className={classes.headerLangDiv}>
                    <img src={langicon} alt="lang" />
                    <p className={classes.headerLinkP}>
                      {multiLanguage
                        ? multiLanguage[langSelection].langName
                        : "Select a lang"}
                    </p>
                    {toggleLang ? <ExpandLess /> : <ExpandMore />}
                  </div>

                  {toggleLang && (
                    <div className={classes.langOptionDiv}>
                      {Object.keys(multiLanguage).map((key, index) => (
                        <div key={key}>
                          <p
                            onClick={() => handleLanguageSelect(index)}
                            className={classes.langLinks}
                          >
                            {multiLanguage[key].langName}
                          </p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                <div
                  onClick={() => setToggleMenu((prev) => !prev)}
                  className={classes.navLinkMenuIcon}
                >
                  <img src={menu} alt="menu" />
                </div>
              </div>

              <div className={classes.navLinkContainerTwo}>
                <div
                  onClick={() => setToggleLang(!toggleLang)}
                  className={classes.headerLangDivSection}
                >
                  <div className={classes.headerLangDiv}>
                    <img src={langicon} alt="lang" />
                    <p className={classes.headerLink}>
                      {multiLanguage
                        ? multiLanguage[langSelection].langName
                        : "Select a lang"}
                    </p>
                    {toggleLang ? <ExpandLess /> : <ExpandMore />}
                  </div>

                  {toggleLang && (
                    <div className={classes.langOptionDiv}>
                      {Object.keys(multiLanguage).map((key, index) => (
                        <div key={key}>
                          <p
                            onClick={() => handleLanguageSelect(index)}
                            className={classes.langLinks}
                          >
                            {multiLanguage[key].langName}
                          </p>
                        </div>
                      ))}
                    </div>
                  )}
                </div>
                {profile &&
                (profile?.userType !== "admin" ||
                  profile?.userType === "fleetadmin") ? (
                  <button
                    className={classes.headerLogInButton}
                    onClick={() => {
                      if (profile?.userType === "admin") {
                        // navigate(`/dashboard`);
                      } else if (profile?.userType === "driver") {
                        navigate(`/bookings`);
                      } else {
                        navigate(`/addbookings`);
                      }
                    }}
                  >
                    {t("myAccount")}
                  </button>
                ) : (
                  <>
                    <Link
                      style={{ textDecoration: "none", color: "inherit" }}
                      to="/login"
                    >
                      <button
                        className={classes.headerLogInButton}
                        onClick={() => navigate(`/login`)}
                      >
                        {t("SignIn")}
                      </button>
                    </Link>
                    <Link
                      style={{ textDecoration: "none", color: "inherit" }}
                      to="/login?signup=true"
                    >
                      <button
                        className={classes.headerSignUpButton}
                        onClick={() => navigate(`/login?signup=true`)}
                      >
                        {t("login_signup")}
                      </button>
                    </Link>
                  </>
                )}
              </div>
            </div>
            {/* MOBILE MENU */}
            {toggleMenu && (
              <div className={classes.mobileMenu}>
                <div className={classes.menuCloseIcon}>
                  <img
                    onClick={() => {
                      navigate("/");
                      setToggleMenu(false);
                    }}
                    src={logo}
                    alt="logo"
                    className={classes.headerLogo}
                  />
                  <Close
                    style={{ color: "#222222" }}
                    onClick={() => setToggleMenu(false)}
                  />
                </div>
                <div className={classes.mobileMenuCLose}>
                  <div className={classes.mobileLinksContainer}>
                    {[...links, ...accountLinks]?.map((link, index) => {
                      return (
                        <div key={index}>
                          <Link
                            style={{ textDecoration: "none", color: "inherit" }}
                            to={link.link}
                          >
                            <p
                              onMouseEnter={() => setHoveredTitle(link?.link)}
                              onMouseLeave={() => setHoveredTitle("")}
                              // onClick={() => {
                              //   navigate(link.link);
                              //   setToggleMenu(false);
                              // }}
                              style={
                                hoveredTitle === link.link ||
                                location.pathname === link.link
                                  ? {
                                      textDecoration: "3px solid underline",
                                      textUnderlineOffset: "5px",
                                    }
                                  : {}
                              }
                              className={classes.headerLink}
                            >
                              {t(link?.title)}
                            </p>
                          </Link>
                        </div>
                      );
                    })}
                  </div>
                  <div className={classes.mobileMenuLinks}>
                    <img
                      src={appstore}
                      alt="Download on App Store"
                      style={{ cursor: "pointer" }}
                      onClick={handleAppStoreClick(
                        settings,
                        "/login?signup=true"
                      )}
                    />
                    <img
                      src={playstore}
                      alt="Get it on Google Play"
                      style={{ cursor: "pointer" }}
                      onClick={handleAppStoreClick(
                        settings,
                        "/login?signup=true"
                      )}
                    />
                    {/* {profile ? (
                      <button
                        className={classes.headerLogInButton}
                        onClick={() => {
                          if (profile?.userType === "admin") {
                            navigate(`/dashboard`);
                          } else if (profile?.userType === "driver") {
                            navigate(`/bookings`);
                          } else {
                            navigate(`/addbookings`);
                          }
                          setToggleMenu(false);
                        }}
                      >
                        {t("myAccount")}
                      </button>
                    ) : (
                      <>
                        <button
                          className={classes.headerLogInButton}
                          onClick={() => {
                            navigate(`/login`);
                            setToggleMenu(false);
                          }}
                        >
                          {t("login")}
                        </button>
                        <button
                          className={classes.headerSignUpButton}
                          onClick={() => {
                            navigate(`/login?signup=true`);
                            setToggleMenu(false);
                          }}
                        >
                          {t("login_signup")}
                        </button>
                      </>
                    )} */}
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
